import { Checkbox } from 'antd';
import Text from 'components/Text';
import { useMemo } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { IPermissionConfigRes } from 'features/settingService/services/types/permission';
import { EPermissionRole } from 'components/Permission/interface';
import settingServiceActions from 'features/settingService/services/actions';


interface RoleHeaderProps {
  role: EPermissionRole;
  label: string;
}

const RoleHeader = ({ role, label }: RoleHeaderProps) => {

  const dataChanged = settingServiceSelectors.getPermissionConfigChanged();
  const dataFiltered = settingServiceSelectors.getPermissionConfigFiltered();
  const dispatch = useAppDispatch();

  const getDataChange = (data: IPermissionConfigRes[] | null, checked: boolean) => {
    return (data ?? []).map((permission) => {
        return {
          ...permission,
          features: permission.features.map(act => {
          return {
            ...act,
            roles: {
              ...act.roles,
              [role]: checked
            }
          };
        })
      };
    });
  };

  const handleChange = (checked: boolean) => {
    dispatch(settingServiceActions.updatePermissionConfigChanged(getDataChange(dataChanged, checked)));
    dispatch(settingServiceActions.updatePermissionConfigFiltered(getDataChange(dataFiltered, checked)));
  };

  const allValueInRole = useMemo(() => {
    return (dataFiltered ?? []).flatMap(permission => permission.features.map(feature => feature.roles[role]));
  }, [dataFiltered]);

  const checkAll = useMemo(() => {
    return !allValueInRole.some(i => i === false);
  }, [allValueInRole]);

  const indeterminate = useMemo(() => {
    return allValueInRole.some(i => i === false) && allValueInRole.some(i => i === true);
  }, [allValueInRole]);
  

  return (
    <RoleHeaderWrapper>
      <Checkbox indeterminate={indeterminate} checked={checkAll} onChange={(e) => handleChange(e.target.checked)} />
      <Text variant='H9'>
        {label}
      </Text>
    </RoleHeaderWrapper>
  );
};

export default RoleHeader;

const RoleHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 8px;
`;